<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8" v-if="!loading">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">id</th>
                <th scope="col">email</th>
                <th scope="col">name</th>
                <th scope="col">Team</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users">
                <td scope="row" style="width:10%">{{user.id}}</td>
                <td style="width:30%">{{user.email}}</td>
                <td style="width:30%">{{user.name}}</td>
                <td style="width:20%">{{user.team}}</td>
                <td style="width:10%"><a v-bind:href="'user/edit/' + user.id">Edit</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";

  export default {
    data () {
      return {
        users: {},
        accessToken: null,
        loading: true,
      }
    },
    async created() {
      try {
        this.accessToken = await this.$auth.getAccessToken()
        this.loadData();
      } catch (e) {
        console.error(e)
      }
    },
    methods:{
      loadData() {
        axios
          .get('user/list?access_token=' + this.accessToken, {})
          .then(response => (
              console.log(response.data),
              this.users = response.data,
              this.loading = false
          ));
      }
    },
  }

</script>
<style>

</style>
